import axios from "./axios";

export interface AdminContractItem {
  id: string;
  slug: string;
  title: string;
  version: string;
  bodyHtml: string;
  isMandatory: boolean;
  isPublished: boolean;
  isArchived: boolean;
  effectiveFrom: string;
  createdAtUtc: string;
  archivedAtUtc?: string | null;
  audienceTargets: number;
  formTargets: number;
}

export async function getAdminContracts(): Promise<AdminContractItem[]> {
  try {
    const response = await axios.get("/admin/contracts");
    return Array.isArray(response.data) ? (response.data as AdminContractItem[]) : [];
  } catch (error) {
    console.error("getAdminContracts error", error);
    return [];
  }
}

export async function createAdminContract(payload: {
  slug: string;
  title: string;
  version: string;
  bodyHtml: string;
  isMandatory: boolean;
  isPublished: boolean;
  effectiveFrom: string;
  audienceTargets: number;
  formTargets: number;
}): Promise<{ success: boolean }> {
  try {
    const response = await axios.post("/admin/contracts", payload);
    return { success: Boolean(response.data?.success ?? true) };
  } catch (error) {
    console.error("createAdminContract error", error);
    return { success: false };
  }
}

export async function deleteAdminContract(
  id: string,
  options?: { hardDelete?: boolean; confirmHardDelete?: boolean; reason?: string },
): Promise<boolean> {
  if (!id) {
    return false;
  }

  const payload = {
    hardDelete: Boolean(options?.hardDelete),
    confirmHardDelete: Boolean(options?.confirmHardDelete),
    reason: options?.reason ?? "admin-contract-delete",
  };

  try {
    await axios.delete(`/admin/contracts/${id}`, { data: payload });
    return true;
  } catch (error) {
    console.error("deleteAdminContract error", error);
    return false;
  }
}
